import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

export const getAllItemsByPK = async (PK: string): Promise<any[] | undefined> => {
  if (!PK) return

  try {
    const url = `${baseUrl}/aws/query/all/${PK}`
    const response = await axios.get(url)

    if (response.status === 204) {
      return undefined
    }

    const sortedItems = [...(response?.data || [])].sort((a, b) => {
      const aIsCore = a?.EntityType === 'organization'
      const bIsCore = b?.EntityType === 'organization'

      if (aIsCore && !bIsCore) return -1
      if (!aIsCore && bIsCore) return 1
      return (a.SK || '').localeCompare(b.SK || '')
    })

    const reorderedItems = sortedItems.map(i => ({
      EntityType: i.EntityType,
      SK: i.SK,
      dba: i.dba,
      mediaSpend: i.mediaSpend,
      ...i, // keep everything else, but these fields stay visually up top
    }))

    return reorderedItems
  } catch (error) {
    console.error(`Error fetching item with PK=${PK} `, error)
    return undefined
  }
}

export const useAllItemsByPK = <T = any>(
  PK: string | undefined,
  queryKey: (string | number | undefined)[] = ['all_org_items', PK]
): {
  data: T | T[] | undefined
  isLoading: boolean
  isError: boolean
} => {
  const { data, isLoading, isError }: UseQueryResult<T | T[] | undefined> = useQuery({
    queryKey,
    queryFn: () => getAllItemsByPK(PK!),
    enabled: !!PK,
    staleTime: Infinity,
  })

  return {
    data,
    isLoading,
    isError,
  }
}
